import { notification,Spin } from 'antd';
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import "./Notifications.scss"
const Notification = () => {
    const [api, contextHolder] = notification.useNotification()
    const notificationData = useSelector((state) => state.PEBCommon?.notificationData);
    // YS in refresh case we don't want notification to go
    // so make this pop-up updatable
    const key = 'updatable';

    const openNotificationWithIcon = ({ message,placement, type, duration = 4.5, onClose = null,loading=false }) => {
        if (type) {
            api[type]({
                key,
                message,
                duration: duration,
                onClose: onClose,
                placement: placement?placement:"topRight",
                icon: loading ? <Spin size="small" /> : null, // 👈 loader here
            });
        }
    };
    useEffect(() => {
        openNotificationWithIcon(notificationData)
    }, [notificationData])
    return (
        <>{contextHolder}</>
    );
};
export const NotificationTypes = {
    SUCCESS : "success" ,
    ERROR : "error" , 
    WARNING : "warning" ,
    INFO : "info"
}

export default Notification;